/**
 * The default provider: the player as it has always behaved.
 *
 * Reset and Check on the left, the pager in the middle, Submit on the right; the default xAPI
 * vocabulary, an answer reported as it is given; page controls drawn by the player, and free to
 * move between pages. Every other provider is a difference from this.
 */

import type { PlayerProvider } from '../types.js';

export const DEFAULT_PROVIDER: PlayerProvider = {
  id: 'default',
  footer: {
    start: ['reset', 'check', 'result'],
    middle: ['pager'],
    end: ['status', 'submit', 'again'],
  },
  xapi: { profile: 'default', answeredAt: 'answer', hints: true, completeOnDone: true },
  hostNavigation: true,
  // Simple pagination: Next goes to the next page, whatever the asset would prefer.
  navigation: 'free',
  // Two checks of a question, then its answer may be shown.
  solutionAfter: 2,
  // Check may be pressed before answering; the question says it is not answered yet.
  checkUnanswered: true,
  // The free-talk bot, over the activity area; `inline` puts it in the step's own box (D78).
  external: { services: ['free-talk'], placement: 'panel' },
  evaluation: false,
};
